import { z } from 'zod'

export const ADMINAGENTSPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminAgentsPostResponseSchema = z.unknown()
export type AdminAgentsPostResponse = z.infer<typeof adminAgentsPostResponseSchema>
